import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreditToolsRoutingModule } from './credit-tools-routing.module';
import { CreditToolsComponent } from './credit-tools.component';
import { RoadmapComponent } from '../../shared/components/roadmap/roadmap.component';
import { LendingLibraryComponent } from '../../shared/components/lending-library/lending-library.component';
import { ArticlesComponent } from '../../shared/components/articles/articles.component';
import { SharedModule } from '../../shared.module';


@NgModule({
  declarations: [
    RoadmapComponent,
    ArticlesComponent,
    CreditToolsComponent,
    LendingLibraryComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CreditToolsRoutingModule,
  ],
  exports:[
    CreditToolsComponent,
    RoadmapComponent
  ]
})
export class CreditToolsModule { }
